// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1FqLX","bigColWidth":"Table_bigColWidth__nNv1Z","biggerColWidth":"Table_biggerColWidth__Wu8CX","row":"Table_row__3f1RH","col":"Table_col__lkhcB"};